import * as Icon from "react-feather";
import { useTranslation } from "react-i18next";
import useRoleAndPerm from "../../utils/permissionFunction";
export const SidebarData = (isAssigned) => {
    const { t, i18n } = useTranslation();
    const { getRedirectLink } = useRoleAndPerm();
    const vendorLink = getRedirectLink("company");
    return [
        {
            label: t("general.main"),
            submenuOpen: true,
            showSubRoute: false,
            submenuHdr: "Main",
            submenuItems: [
                {
                    label: t("tableColumnName.dashboard"),
                    icon: <Icon.Home />,
                    link: "/",
                    submenu: false,
                    showSubRoute: false,
                    is_assigned: isAssigned("dashboard-view"),
                },
            ],
        },
        {
            label: t("company.company"),
            submenuOpen: true,
            showSubRoute: false,
            submenuHdr: "People",

            submenuItems: [
                {
                    label: t("company.company"),
                    link: vendorLink,
                    icon: <Icon.ShoppingBag />,
                    showSubRoute: false,
                    is_assigned: isAssigned("company-view"),
                },
                {
                    label: t("shopper.shopper"),
                    link: "/shoppers-list",
                    icon: <Icon.User />,
                    showSubRoute: false,
                    submenu: false,
                    is_assigned: isAssigned("shopper-view"),
                },
            ],
        },
        {
            label: t("Sales.Sale"),
            submenuOpen: true,
            showSubRoute: false,
            submenuHdr: "Sales List",
            submenuItems: [
                {
                    label: t("Sales.saleOrders"),
                    icon: <Icon.FileText />,
                    showSubRoute: false,
                    is_assigned: isAssigned("sale-view"),
                    link: "/sales-list",
                },
            ],
        },
        {
            label: t("tableColumnName.shop"),
            submenuOpen: true,
            showSubRoute: false,

            submenuItems: [
                {
                    label: t("tableColumnName.shop"),
                    link: "/outlets-list",
                    icon: <Icon.ShoppingBag />,
                    showSubRoute: false,
                    submenu: false,
                    is_assigned: isAssigned("shop-view"),
                },
                {
                    label: t("tableColumnName.entryExitLogs"),
                    link: "/outlet-logs-list",
                    icon: <Icon.List />,
                    showSubRoute: false,
                    submenu: false,
                    is_assigned: isAssigned("shop-view"),
                },
                {
                    label: t("tableColumnName.cctv"),
                    link: "/cctv-list",
                    icon: <Icon.List />,
                    showSubRoute: false,
                    submenu: false,
                    is_assigned: isAssigned("cctv-view"),
                },
            ],
        },

        {
            label: t("product.product"),
            submenuOpen: true,
            showSubRoute: false,
            submenuHdr: "Products",

            submenuItems: [
                {
                    label: t("product.lmProduct"),
                    link: "/product-list",
                    icon: <Icon.Box />,
                    showSubRoute: false,
                    submenu: false,
                    is_assigned: isAssigned("product-view"),
                },
                {
                    label: t("brand.brand"),
                    link: "/brand-list",
                    icon: <Icon.Tag />,
                    showSubRoute: false,
                    submenu: false,
                    is_assigned: isAssigned("brand-view"),
                },

                {
                    label: t("UOM.UOM"),
                    link: "/uom-list",
                    icon: <Icon.Speaker />,
                    showSubRoute: false,
                    submenu: false,
                    is_assigned: isAssigned("uom-view"),
                },
                {
                    label: t("category.category"),
                    link: "/category-list",
                    icon: <Icon.Codepen />,
                    showSubRoute: false,
                    submenu: false,
                    is_assigned: isAssigned("category-view"),
                },
            ],
        },
        {
            label: "Reports",
            submenuOpen: true,
            showSubRoute: false,
            submenuHdr: "Reports",
            submenuItems: [
                {
                    label: "Sales",
                    link: "/sales-report",
                    icon: <Icon.BarChart2 />,
                    showSubRoute: false,
                    is_assigned: isAssigned("sales-report-view"),
                },
                {
                    label: "Purchase",
                    link: "/purchase-report",
                    icon: <Icon.PieChart />,
                    showSubRoute: false,
                    is_assigned: isAssigned("purchase-report-view"),
                },
                {
                    label: "Shopper",
                    link: "/shopper-report",
                    icon: <Icon.User />,
                    showSubRoute: false,
                    is_assigned: isAssigned("shopper-report-view"),
                },
            ],
        },
        {
            label: t("user.userManagment"),
            submenuOpen: true,
            showSubRoute: false,
            submenuHdr: "User Management",
            submenuItems: [
                {
                    label: t("user.users"),
                    icon: <Icon.Users />,
                    showSubRoute: false,
                    is_assigned: isAssigned("user-view"),
                    link: "/user-list",
                },
                {
                    label: t("role.rolesAndPermissions"),
                    link: "/role-list",
                    icon: <Icon.UserCheck />,
                    showSubRoute: false,
                    is_assigned: isAssigned("role-view"),
                },
                {
                    label: t("employee.employees"),
                    link: '/employee-list',
                    icon: <Icon.UserPlus />,
                    is_assigned: isAssigned("employee-view"),
                    showSubRoute:false,
                },
                {
                    label: t("designation.designation"),
                    link: "/designation",
                    icon: <Icon.Briefcase />,
                    showSubRoute: false,
                    is_assigned: isAssigned("designation-view"),
                },
            ],
        },
        {
            label: t("tableColumnName.settings"),
            submenuOpen: true,
            showSubRoute: false,
            submenuHdr: "Settings",
            submenuItems: [
               /*  {
                    label: t("notification.notification"),
                    link: "/notification-list",
                    icon: <Icon.Bell />,
                    showSubRoute: false,
                    submenu: false,
                    is_assigned: isAssigned("notification-view"),
                }, */
                {
                    label: t("tableColumnName.logs"),
                    link: "/logs-list",
                    icon: <Icon.Folder />,
                    showSubRoute: false,
                    is_assigned: isAssigned("log-view"),
                },
                {
                    label: t("systemLanguage.systemLanguage"),
                    link: "/system-language-list",
                    icon: <Icon.Globe />,
                    showSubRoute: false,
                    is_assigned: isAssigned("language-view"),
                },
                {
                    label: t("inputField.label.faq"),
                    link: "/faq-list",
                    icon: <Icon.List />,
                    showSubRoute: false,
                    is_assigned: isAssigned("language-view"),
                },
                {
                    label: t("inputField.label.faqType"),
                    link: "/faq-type-list",
                    icon: <Icon.List />,
                    showSubRoute: false,
                    is_assigned: isAssigned("language-view"),
                },
                {
                    label: t("tableColumnName.countries"),
                    link: "/country-list",
                    icon: <Icon.Globe />,
                    showSubRoute: false,
                    is_assigned: isAssigned("country-view"),
                },{
                    label: t("tableColumnName.appSettings"),
                    link: "/update-app-settings",
                    icon: <Icon.Settings />,
                    showSubRoute: false,
                    is_assigned: isAssigned("setting-view"),
                },
            ],
        },
        {
            label: t("tableColumnName.support"),
            submenuOpen: true,
            showSubRoute: false,
            submenuItems: [
                {
                    label: t("ticket.ticketList"),
                    link: "/ticket-list",
                    icon: <Icon.ShoppingBag />,
                    showSubRoute: false,
                    submenu: false,
                    is_assigned: isAssigned("ticket-view"),
                },
            ],
        },
        {
            label: t("thirdParty.thirdParty"),
            submenuOpen: true,
            showSubRoute: false,
            submenuItems: [
                {
                    label: t("thirdParty.thirdPartyList"),
                    link: "/third-party-list",
                    icon: <Icon.Code />,
                    showSubRoute: false,
                    submenu: false,
                    is_assigned: isAssigned("third-party-view"),
                },
            ],
        },
    ];
};
